/* eslint-disable import/prefer-default-export */

/** Enable Course Planning Exercise */
export const enableCPExforProd = false;

export const showCPExTab = false;
